/**
 * Currently, this hook doesn't actually return an IComputedProperty, as I've been unable to get it to work
 * as expected when gettors reference non-observable values, such as component props.
 * As such, currently just returns a getter.
 * https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/63552
 */
export function useComputed<T>(getter: () => T): { get(): T } {
    return {
        get: getter,
    };
}
